<template>
    <div class="profile">
        <div class="module">
            <div class="container container--full container--unpadded container--nooverflow">
                <div class="profile__inner">
                    <div class="profile__sidebar">
                        <ProfileSidebar></ProfileSidebar>
                    </div>

                    <div class="profile__main">
                        <div class="profile__main__inner">
                            <router-view name="default"></router-view>
                        </div>
                        <Footer></Footer>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex"
import { storeUser } from '../utils/authentication';
import * as api from '../api'

import ProfileSidebar from '@/components/ProfileSidebar'
import Footer from '@/components/Footer'

export default {
    components: {
        ProfileSidebar,
        Footer,
    },
    data() {
        return {
            apple_link: 'https://apps.apple.com/us/app/pumatrac-training-running/id698298978',
            apple_image: require('@/assets/img/appstore.svg'),
            apple_title: this.$gettext('download_on_app_store'),
            google_link: 'https://play.google.com/store/apps/details?id=com.pumapumatrac',
            google_image: require('@/assets/img/play-store.svg'),
            google_title: this.$gettext('download_on_google_play'),
        }
    },
    computed: {
        ...mapGetters(['user']),
    },
    mounted() {
        this.reloadUser()
    },
    methods: {
        async reloadUser() {
            try {
                const userResponse = await api.users.me();
                const userResponseData = userResponse.data.data;
                storeUser(userResponseData)
            } catch(error) {
                console.error(error)
            }
        }
    }
}
</script>


<style lang="scss" scoped>
.profile {
    $block: &;

    &__inner {
        display: flex;

        @include mq($until: tablet-landscape) {
            flex-direction: column;
        }
    }

    &__sidebar {
        position: sticky;
        top: $nav-height-desktop;
        min-height: calc(100vh - #{$nav-height-desktop});
        height: 100%;
        background: rgba(black, 0.05);
        width: calc(3 * 100% / 12);

        @include mq($until: notebook) {
            width: calc(4 * 100% / 12);
        }

        @include mq($until: tablet-landscape) {
            min-height: 0;
            width: 100%;
            position: relative;
            top: 0;
            height: auto;
        }
    }

    &__main {
        width: calc(9 * 100% / 12);

        @include mq($until: notebook) {
            width: calc(8 * 100% / 12);
        }

        @include mq($until: tablet-landscape) {
            width: 100%;
        }

        &__inner {
            padding: 70px 80px;
            border-bottom: 1px solid rgba(black, 0.1);

            @include mq($until: notebook) {
                padding: 60px 40px;
            }

            @include mq($until: tablet-landscape) {
                padding: 30px $page-padding-small 30px;
            }
        }
    }
}
</style>